import * as yup from 'yup';
import { I18n } from 'react-redux-i18n';

import {
  ENTITIES,
  DEFAULT_REGISTRATION_AGE,
  MAX_AGE,
  NICKNAME_PATTERN,
} from './constants';

export const getSchema = activeEntity => {
  const REQUIRED_FIELD = I18n.t('auth.requiredField');

  const PHONE_MIN_LENGTH = 5;
  const PHONE_MAX_LENGTH = 20;

  const PASSWORD_MAX_LENGTH = 20;

  const REAL_NAME_MIN_LENGTH = 2;
  const REAL_NAME_MAX_LENGTH = 25;

  const AGE_MIN = 1;
  const AGE_MAX = 100;

  const EMAIL_MIN_LENGTH = 5;
  const EMAIL_NAME_MAX_LENGTH = 254;

  const basePhoneRule = yup
    .string()
    .min(
      PHONE_MIN_LENGTH,
      I18n.t('auth.minLength', { minLength: PHONE_MIN_LENGTH })
    )
    .max(
      PHONE_MAX_LENGTH,
      I18n.t('auth.maxLength', { maxLength: PHONE_MAX_LENGTH })
    );

  const baseEmailRule = yup
    .string()
    .email(I18n.t('register.errors.email.wrong'))
    .min(
      EMAIL_MIN_LENGTH,
      I18n.t('auth.minLength', { minLength: EMAIL_MIN_LENGTH })
    )
    .max(
      EMAIL_NAME_MAX_LENGTH,
      I18n.t('auth.maxLength', { maxLength: EMAIL_NAME_MAX_LENGTH })
    );

  const baseRealNameRule = yup
    .string()
    .min(
      REAL_NAME_MIN_LENGTH,
      I18n.t('auth.minLength', { minLength: REAL_NAME_MIN_LENGTH })
    )
    .max(
      REAL_NAME_MAX_LENGTH,
      I18n.t('auth.maxLength', {
        maxLength: REAL_NAME_MAX_LENGTH,
      })
    );

  const passwordRule = yup
    .string()
    .required(REQUIRED_FIELD)
    .min(8, I18n.t('register.errors.password.length'))
    .max(
      PASSWORD_MAX_LENGTH,
      I18n.t('register.errors.password.maxLength', {
        maxLength: PASSWORD_MAX_LENGTH,
      })
    );

  const requiredForKid = {
    is: val => val < MAX_AGE,
    then: schema => schema.required(REQUIRED_FIELD),
  };

  const requiredForTeenager = {
    is: val => val >= MAX_AGE,
    then: schema => schema.required(REQUIRED_FIELD),
  };

  const parentAndTeacherValidation = {
    email: baseEmailRule.required(REQUIRED_FIELD),
    password: passwordRule,
    realName: baseRealNameRule.required(REQUIRED_FIELD),
    phone: basePhoneRule.required(REQUIRED_FIELD),
  };

  const staticValidations = {
    [ENTITIES.student]: {
      name: yup
        .string()
        .transform(value =>
          typeof value === 'string' ? value.trim() : value
        )
        .required(REQUIRED_FIELD)
        .matches(NICKNAME_PATTERN, I18n.t('register.errors.nickname.wrong')),
      password: passwordRule,
      age: yup
        .number()
        .default(DEFAULT_REGISTRATION_AGE)
        .typeError(I18n.t('register.errors.age.wrong'))
        .required(REQUIRED_FIELD)
        .min(
          AGE_MIN,
          I18n.t('register.errors.age.min', { min: AGE_MIN })
        )
        .max(
          AGE_MAX,
          I18n.t('register.errors.age.max', { max: AGE_MAX })
        ),
      realName: baseRealNameRule.when('age', requiredForTeenager),
      email: baseEmailRule.when('age', requiredForTeenager),
      parentRealName: baseRealNameRule.when('age', requiredForKid),
      parentEmail: baseEmailRule.when('age', requiredForKid),
      parentPhone: basePhoneRule.when('age', requiredForKid),
    },
    [ENTITIES.parent]: parentAndTeacherValidation,
    [ENTITIES.teacher]: parentAndTeacherValidation,
  };

  return yup.object().shape(staticValidations[activeEntity]);
};
